import * as React from 'react'

import Button from 'components/Button'
import { FormRow, TextInputContainer } from 'components/inputs'
import { observer } from 'mobx-react'
import DocumentUploadInputEditorViewModel from './DocumentUploadInputEditorViewModel'
import DocumentUploadItemViewModel from './DocumentUploadItemViewModel'

interface DocumentUploadInputEditorProps {
  vm: DocumentUploadInputEditorViewModel
}

export default observer(function DocumentUploadInputEditor({
  vm,
}: DocumentUploadInputEditorProps) {
  return (
    <>
      {vm.documentUploadItems.map((itemVM) => (
        <FormRow key={itemVM.id}>
          <DocumentUploadItem
            vm={itemVM}
            onRemoveClick={vm.removeDocumentUploadItem}
            isRemovable={vm.isRemovable}
          />
        </FormRow>
      ))}
      <FormRow>
        {vm.isAppendable && (
          <Button
            type="text"
            data-test="prompt-add-document-button"
            onClick={vm.addDocumentUploadItem}
          >
            + Add another document
          </Button>
        )}
      </FormRow>
    </>
  )
})

interface DocumentUploadItemProps {
  vm: DocumentUploadItemViewModel
  isRemovable: boolean
  onRemoveClick: (id: string) => void
}

const DocumentUploadItem = observer(
  ({ vm, isRemovable, onRemoveClick }: DocumentUploadItemProps) => {
    return (
      <TextInputContainer
        model={vm}
        field="title"
        name="title"
        label="Document title"
        placeholder="The title for the document."
        error={vm.validation.getError('title')}
        data-test={'prompt-document-title-input-' + vm.title}
        button={
          isRemovable && (
            <Button
              dataTest={'prompt-document-remove-button-' + vm.title}
              onClick={() => onRemoveClick(vm.id)}
            >
              Remove
            </Button>
          )
        }
      />
    )
  },
)
